import React from 'react'
import './Footer.css'
import '../../Global.css'
function Footer() {
  return (
    <div className="footer">
        <p>&copy; Sandeep Ruttala, 2024</p>
    </div>
  )
}

export default Footer
